import { TextareaAutosize, TextField } from "@mui/material";
import React, { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { setJobDetaialsModal } from "../../../redux/userReducer";
import CrossIcon from "../../../asset/jobs/close-circle.svg";
import { Tabs, Tab, Box } from "@mui/material";
// import CommonInput from "../commonInput/commonInput";
import "./JobPostDetailsModal.scss";
import graphqlRequest from "../../../requestMethod";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { message } from "../../Common/SnakeAlert/SnakeAlert";
import ProfessionalDetailsUser from "./ProfessionalDetailsUser";
import { pushEvent } from "../../../utils/clevertap";
// Import icons for download buttons
// import DownloadIcon from "../../../asset/jobs/download.svg";
// import ResumeIcon from "../../../asset/jobs/resume.svg";
// import CertificateIcon from "../../../asset/jobs/certificate.svg";
const JobPostDetailsModal = ({ selectedData,routeName }) => {
  const eventTriggered = useRef(false);

useEffect(() => {
  if (selectedData && !eventTriggered.current && selectedData?.id) {

    pushEvent(`Web_${routeName}_ViewDetails`, {
      page: "Applicant Details",
    
      applicationID: selectedData?.allData?.id,
      status: selectedData?.allData?.status,
    
      // ✅ Job Details (flattened)
      jobId: selectedData?.allData?.job?.id,
      jobCode: selectedData?.allData?.job?.code,
      hospitalName: selectedData?.allData?.job?.hospitalName,
      department: selectedData?.allData?.job?.department,
      specialization: selectedData?.allData?.job?.specialization,
      jobStart: selectedData?.allData?.job?.start,
      jobEnd: selectedData?.allData?.job?.end,
    
      contactPerson: selectedData?.allData?.job?.contactDetail?.contactPerson,
      contactEmail: selectedData?.allData?.job?.contactDetail?.email,
      contactPhone: selectedData?.allData?.job?.contactDetail?.phone,
    
      // ✅ Professional Details (flattened)
      userId: selectedData?.allData?.professional?.id,
      name: selectedData?.allData?.professional?.name?.full,
      email: selectedData?.allData?.professional?.emails?.find(e => e.isPrimary)?.address,
      phone: selectedData?.allData?.professional?.phoneNumbers?.find(p => p.isPrimary)?.number,
    
      userCity: selectedData?.allData?.professional?.workCity?.name,
      userState: selectedData?.allData?.professional?.address?.state,
      experience: selectedData?.allData?.professional?.numExperience?.name,
      qualification: selectedData?.allData?.professional?.qualification?.name,
      professionalType: selectedData?.allData?.professional?.professionalType?.name,
    
      // optional useful fields
      registrationNumber: selectedData?.allData?.professional?.professionalRegistration?.number,
      profileStatus: selectedData?.allData?.professional?.status,
    });

    eventTriggered.current = true; // ✅ ensures it runs only once
  }
}, [selectedData]);
  
  let data = localStorage.getItem("auth");
  let token = JSON.parse(data)?.accessToken;
  const [tab, setTab] = useState(0);
  const [hasVerificationCertificate, setHasVerificationCertificate] = useState(false);
 const handleResume = (url) => {
   let resumeUrl = url?.AIResumeUrl || url?.manualResumeUrl || url;
   if (resumeUrl.startsWith("http://")) {
     resumeUrl = resumeUrl.replace("http://", "https://");
   }
   console.log("Resume URL:", resumeUrl);

   if (resumeUrl) {
     const viewerUrl = `/pdf-viewer.html?pdfUrl=${encodeURIComponent(
       resumeUrl
     )}`;
     window.open(viewerUrl, "_blank");
   }
 };
 
  const getFileExtension = (url) => {
    const parts = url.split(".");
    // console.log(">>>>>>>1>>>>>>>",parts)
    // const data1 = parts[parts.length - 1].split("?")[0];
    // console.log(">>>>>>>2>>>>>>>",data1)
    // return data1 
    return parts[parts.length - 1].split("?")[0];
  };
 
const handleTabChange = (event, newValue) => {
  setTab(newValue);
};
  console.log("selectedDataselectedData", selectedData);
  let dispatch = useDispatch();
  function handleJobPost(jobType) {
    dispatch(setJobDetaialsModal());
  }
  let pocName = selectedData?.allData?.pocDetails?.contactPerson
    ? selectedData?.allData?.pocDetails?.contactPerson
    : selectedData?.allData?.job?.contactDetail?.contactPerson;
  let pocEmail = selectedData?.allData?.pocDetails?.email
    ? selectedData?.allData?.pocDetails?.email
    : selectedData?.allData?.job?.contactDetail?.email;
  let pocContact = selectedData?.allData?.pocDetails?.phone
    ? selectedData?.allData?.pocDetails?.phone
    : selectedData?.allData?.job?.contactDetail?.phone;
    let professionalData = selectedData?.allData?.professional
const handleRegistration = () => {
  const registrationDoc = professionalData?.documents?.find(
    (doc) => doc?.docType?.name === "REGISTRATION"
  );

  const url = registrationDoc?.files?.[0]?.url;

  console.log("Registration URL:", url);

  if (url) {
    window.open(url, "_blank");
  }
};
const handleDownLoadVerification = () => {
  // setIsVerificationDownloading(true);
  const query1 = `{
  withAuth(token:"${token}"){
    getDownloadVerification(userId: "${professionalData?.id}"){
     pdfUrl
    }
  }
}`;

  graphqlRequest(query1)
    .then((response) => {
      const documents =
        response?.data?.withAuth?.getDownloadVerification || [];
      if (documents && documents.pdfUrl) {
        let linkSource = documents.pdfUrl;
        if (linkSource.startsWith("http://")) {
          linkSource = linkSource.replace("http://", "https://");
        }
        const viewerUrl = `/pdf-viewer.html?pdfUrl=${encodeURIComponent(
          linkSource
        )}`;
        window.open(viewerUrl, "_blank");
        fetch(linkSource)
          .then((res) => res.blob())
          .then((blob) => {
            const filename = `${
              professionalData?.name?.full
            }_verification.${getFileExtension(linkSource)}`;
            // console.log("hnadleResume,  here 1")
            // const url = window.URL.createObjectURL(blob);
            // const a = document.createElement("a");
            // a.href = url;
            // a.download = filename;
            // a.style.display = "none";
            // document.body.appendChild(a);
            // a.click();
            // window.URL.revokeObjectURL(url);
            // setIsVerificationDownloading(false);
          })
          .catch((error) => {
            // setIsVerificationDownloading(false);
            message.error("Failed to view the file.");
          });
      } else {
        message.error("No verification certificate available.");
        // setIsVerificationDownloading(false);
      }
    })
    .catch((error) => {
      // setIsVerificationDownloading(false);
      message.error("Failed to fetch the resume.");
    });
};
const checkVerificationInvoiceList = () => {
  const query1 = `{
    withAuth(token:"${token}"){
      getDownloadVerification(userId: "${professionalData?.id}"){
        pdfUrl
      }
    }
  }`;

  graphqlRequest(query1)
    .then((response) => {
      const documents =
        response?.data?.withAuth?.getDownloadVerification;

      if (documents?.pdfUrl) {
        setHasVerificationCertificate(true);
      } else {
        setHasVerificationCertificate(false);
      }
    })
    .catch((error) => {
      console.log(error);
      setHasVerificationCertificate(false);
    });
};

useEffect(() => {
  if (professionalData?.id) {
    checkVerificationInvoiceList();
  }
}, [professionalData?.id]);
const getInitials = (fullName) => {
  if (!fullName) return "";

  // remove titles like Dr.
  const name = fullName.replace(/^dr\.?\s*/i, "").trim();

  const parts = name.split(" ");

  if (parts.length === 1) {
    return parts[0][0]?.toUpperCase();
  }

  return (parts[0][0] + parts[1][0]).toUpperCase();
};

const cardStyle = {
  padding: "20px",
  background: "#f8fafc",
  borderRadius: "12px",
  border: "1px solid #e2e8f0",
  transition: "all 0.3s ease",
};

const labelStyle = {
  fontSize: "12px",
  color: "#64748b",
  fontWeight: 600,
  letterSpacing: "0.5px",
  textTransform: "uppercase",
  display: "block",
  marginBottom: "8px",
};

const valueStyle = {
  fontSize: "16px",
  fontWeight: 600,
  color: "#1e293b",
  lineHeight: "1.5",
  margin: 0,
};
  return (
    <>
      <div className="JobPostDetailsModal1-container">
        <div style={{ display: "flex", justifyContent: "space-between" , paddingBottom: "20px"}}>
          <p></p>
          <img
            src={CrossIcon}
            onClick={handleJobPost}
            style={{ cursor: "pointer" }}
          />
        </div>
        <Box sx={{ borderBottom: 0, borderColor: "divider", mb: 3 }}>
  <Tabs 
    value={tab} 
    onChange={handleTabChange}
    sx={{
      '& .MuiTabs-flexContainer': {
        '@media (max-width: 600px)': {
          justifyContent: 'space-between',
        }
      },
      '& .MuiTab-root': {
        '@media (max-width: 600px)': {
          fontSize: '14px',
          fontWeight: 600,
          minWidth: 'auto',
          px: 1,
        }
      }
    }}
  >
    <Tab label="Professional Details" sx={{ fontSize: "18px", fontWeight: 600 }} />
    <Tab label="Job Details" sx={{ fontSize: "18px", fontWeight: 600 }} />
  </Tabs>
</Box>
{tab === 1 && (
  <>
    {/* ALL YOUR CURRENT CODE WITHOUT ANY CHANGE */}
    <section style={{ 
  marginTop: "40px",
  '@media (max-width: 600px)': {
    marginTop: "20px"
  }
}}>
  <div
    style={{
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
      gap: "24px",
      '@media (max-width: 600px)': {
        gridTemplateColumns: "1fr",
        gap: "16px"
      }
    }}
  >
    <div style={cardStyle}>
      <label style={labelStyle}>Branch</label>
      <p style={valueStyle}>
        {selectedData?.allData?.job?.hospitalName ||
          selectedData?.allData?.branch}
      </p>
    </div>

    <div style={cardStyle}>
      <label style={labelStyle}>Type of Professional</label>
      <p style={valueStyle}>
        {selectedData?.allData?.professional?.professionalType?.name}
      </p>
    </div>

    <div style={cardStyle}>
      <label style={labelStyle}>Department</label>
      <p style={valueStyle}>{selectedData?.allData?.job?.department}</p>
    </div>

    <div style={cardStyle}>
      <label style={labelStyle}>Specialization</label>
      <p style={valueStyle}>{selectedData?.specialization}</p>
    </div>

    <div style={cardStyle}>
      <label style={labelStyle}>Qualification</label>
      <p style={valueStyle}>
        {selectedData?.allData?.professional?.qualification?.name}
      </p>
    </div>

    <div style={cardStyle}>
      <label style={labelStyle}>Experience</label>
      <p style={valueStyle}>
        {selectedData?.allData?.professional?.numExperience?.name}
      </p>
    </div>

    <div style={cardStyle}>
      <label style={labelStyle}>No. of Jobs</label>
      <p style={valueStyle}>
        {selectedData?.allData?.job?.applications?.split("/")[1] ||
          selectedData?.allData?.job?.applicants}
      </p>
    </div>

    <div style={cardStyle}>
      <label style={labelStyle}>Name - POC (Shift In-Charge)</label>
      <p style={valueStyle}>{pocName}</p>
    </div>

    <div style={cardStyle}>
      <label style={labelStyle}>Email - POC (Shift In-Charge)</label>
      <p style={valueStyle}>{pocEmail}</p>
    </div>

    <div style={cardStyle}>
      <label style={labelStyle}>Phone - POC (Shift In-Charge)</label>
      <p style={valueStyle}>{pocContact}</p>
    </div>
  </div>
</section>

        <div className="detailsModal-desc">
          <p style={{ color: "#454545" }}>Job description</p>
          <textarea
            disabled
            aria-label="minimum height"
            // value={selectedData?.jD}
            value={(() => {
              try {
                const jd = selectedData?.jD || selectedData?.allData?.job?.jobDescription;
                const parsed =
                  typeof jd === "string" && jd.startsWith("{")
                    ? JSON.parse(jd)
                    : jd;

                return typeof parsed === "string"
                  ? parsed.replace(/\\n/g, "\n")
                  : parsed;
              } catch (err) {
                return selectedData?.jD || "";
              }
            })()}
            placeholder="Type Here"
            rows="8"
            cols="80"
            style={{
              // width: "100%",
              border: "none",
              outline: "none",
              background: "#F7F7F7",
              borderRadius: "8px",
              padding: "10px",
              resize: "none",
              overFlowX: "auto",
            }}
          ></textarea>
        </div>
        {/* <div className="detailsModal-buttonsDiv">
        <button
          className="detailsModal-buttonsNo"
          onClick={() => handleJobPost()}
        >
          No
        </button>
        <button
          className="detailsModal-buttonsYes"
          onClick={() => handleJobPost()}
        >
          Yes
        </button>
      </div> */}
      </>)}
      {tab === 0 && (
      <ProfessionalDetailsUser
        professionalData={professionalData}
        hasVerificationCertificate={hasVerificationCertificate}
        handleResume={handleResume}
        handleRegistration={handleRegistration}
        handleDownLoadVerification={handleDownLoadVerification}
        getInitials={getInitials}
      />
)}
      </div>

    </>
  );
};

export default JobPostDetailsModal;
